import { render } from "./itHome.vue?vue&type=template&id=76d67f73"
import script from "./itHome.vue?vue&type=script&lang=js"
export * from "./itHome.vue?vue&type=script&lang=js"

import "./itHome.vue?vue&type=style&index=0&id=76d67f73&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__